import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import { Link } from 'react-router-dom';
import Spacing from '../Spacing';
// import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
// import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
import { COMPANY_NAME, COMPANY_WHATSAPP, COMPANY_FOOTER_BRAND_LINES } from '../../constants/brand';
// const menuDataOne = [
//   { title: 'About Us', href: '/about' },
//   { title: 'Departments', href: '/departments' },
//   { title: 'Doctors', href: '/doctors' },
//   { title: 'Timetable', href: '/timetable' },
//   { title: 'Appointment', href: '/appointments' },
//   { title: 'Testimonials', href: '/' },
// ];
// const menuDataTwo = [
//   { title: 'Blog', href: '/blog' },
//   { title: 'Contact Us', href: '/contact' },
//   { title: 'FAQs', href: '/' },
//   { title: 'Privacy Policy', href: '/' },
//   { title: 'Terms and Conditions', href: '/' },
// ];
const btnText="Chat With Us"
const btnUrl=COMPANY_WHATSAPP
const footerDesc = `At ${COMPANY_NAME}, we bridge world-class healthcare with seamless travel experiences, making Kerala a global hub for medical tourism. From specialized treatments to holistic wellness programs, we ensure a stress-free journey with expert guidance, personalized care, and comprehensive support. Whether you seek advanced medical care or Ayurvedic healing, we are here to make your health and wellness journey effortless. 🌍✨`
const developed_by = "Geek Studios ⚡"
const developer_url = "https://wa.me/919947451753"

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            src="/images/logo_icon.svg"
            alt={COMPANY_NAME}
            className="cs_footer_brand_icon"
          />
          <h2 className="cs_footer_brand_text">
            {COMPANY_FOOTER_BRAND_LINES.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="cs_footer_item">
                <TextWidget text={COMPANY_NAME} />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cs_footer_item">
                <p className='m-0 text-justify'>{footerDesc}</p>
                <Spacing md="20" lg="20" sm="20" />
                <Link to={btnUrl} className="cs_btn cs_style_1">
                  <span>{btnText}</span>
                  <i>
                    <img src="/images/icons/arrow_white.svg" alt="Icon" />
                    <img src="/images/icons/arrow_white.svg" alt="Icon" />
                  </i>
                </Link>
                {/* <MenuWidget data={menuDataOne} /> */}
              </div>
            </div>
            {/* <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataOne} />
              </div>
            </div> */}
            {/* <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataTwo} />
              </div>
            </div> */}
            {/* <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title="Be Our Subscribers"
                  subTitle="To get the latest news about health from our experts"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © {currentYear} {COMPANY_NAME}. All rights reserved.<br></br>
              <a href={developer_url} className='cs_white_color developed_by'>Developed & maintained by {developed_by}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
